import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthHeader } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [checking, setChecking] = useState(true);

  const refresh = useCallback(async () => {
    const token = typeof window !== "undefined" ? localStorage.getItem("lecis_admin_token") : null;
    if (!token) { setAdmin(false); setPermissions([]); setChecking(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
      try {
        const perms = await api.get("/auth/permissions");
        setPermissions(perms.data.permissions || []);
      } catch { setPermissions([]); }
    } catch {
      setAuthHeader(null);
      setAdmin(false);
      setPermissions([]);
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.token) setAuthHeader(data.token);
    setAdmin(data.user);
    try {
      const perms = await api.get("/auth/permissions");
      setPermissions(perms.data.permissions || []);
    } catch { setPermissions([]); }
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setAuthHeader(null);
    setAdmin(false);
    setPermissions([]);
  };

  const hasPerm = (p) => permissions.includes(p);

  return (
    <AuthCtx.Provider value={{ admin, permissions, hasPerm, checking, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
